import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_LP_ALLOCATION, REPORT_CONFIG_NAME_LP_ALLOCATION } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the LP Allocation grid column layout (from global configs). */
export function useLpAllocationReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () => resolveReportIdForMenuItem(reportingConfigs, menuItems, MENU_ITEM_KEY_LP_ALLOCATION, REPORT_CONFIG_NAME_LP_ALLOCATION),
    [menuItems, reportingConfigs]
  )
}
